import {
  langdeck_projects_saynetes_smart,
} from "../img/index.js";


export const saynetes_sections = [
  {
    "id": "desc",
    "href": "#sayndesc",
    "label": "Les Saynètes c'est quoi ?",
    "illustration": langdeck_projects_saynetes_smart,
    "content": [
      {
        "text": "Les saynètes sont de petites histoires mettant en scène des personnages.",
        "style": "text-lg text-blue-700"
      },
      {
        "text": "Elles sont spécialement conçues pour non francophones.",
        "style": "text-lg text-blue-700"
      },
      {
        "text": "Elles ont pour objectif de sensibiliser sur des thèmes comme le diabète, l'alimentation et la pratique d'exercices physiques.", 
        "style": "text-lg text-blue-700"
      },
      {
        "text": "Les saynètes mettent en scène des professionnels de santé et des patients ne parlant pas le français.",
        "style": "text-lg text-blue-700"
      },
    ]
  },
  {
    "id": "hist",
    "href": "#cardsyst",
    "label": "Comment ça marche ?",
    "illustration": "https://hammer-marteau.com/assets/video/clip-saynetes-v1.0-2.mp4",
    "content": [
      {
        "text": "Les saynètes sont disponibles en plusieurs langues.",
        "style": "text-lg text-blue-700"
      },
      {
        "text": "Les traductions ne proviennent pas d'outils de traduction automatique",
        "style": "text-lg text-blue-700"
      },
      {
        "text": "Elles sont générées en partie par des algorithmes d'intelligence artificielle", 
        "style": "text-lg text-blue-700"
      },
      {
        "text": "Puis elles sont revues par des interprètes professionnels connaissant parfaitement le monde de la santé et son vocabulaire.",
        "style": "text-lg text-blue-700"
      },
    ]
  },
  {
    "id": "about",
    "href": "#about",
    "label": "Qui sommes-nous ?",
    "illustration": "https://hammer-marteau.com/assets/video/clip-saynetes-v1.0-2.mp4",
    "content": [
      {
        "text": "Les saynètes sont disponibles en plusieurs langues.",
        "style": "text-lg text-blue-700"
      },
      {
        "text": "Les traductions ne proviennent pas d'outils de traduction automatique",
        "style": "text-lg text-blue-700"
      },
      {
        "text": "Elles sont générées en partie par des algorithmes d'intelligence artificielle", 
        "style": "text-lg text-blue-700"
      },
      {
        "text": "Puis elles sont revues par des interprètes professionnels connaissant parfaitement le monde de la santé et son vocabulaire.",
        "style": "text-lg text-blue-700"
      },
    ]
  },
];

export const base_server_url = "https://hammer-marteau.com/";

export const activation_matrix = {};